// import React, { useEffect, useState } from 'react';
// import { useUserAuth } from '../context/UserAuthContext';
// import { useNavigate } from 'react-router-dom';
// import SplashScreen from './components/SplashScreen';
// import moment from 'moment';
// import NoInternetPopup from './components/NoInternetPopup';

// export const Index = () => {
//   const navigate = useNavigate();
//   const { auth, user, programRenewalData, checkPhysioExist, setEvent, setDocEvent, getAllPrograms, GetAllPhysioData, fetchPhysioData, WeeklyUpcomingAppointmentsData, fetchCompleteSlotData,VideoCallHistoryData, ADDingdata, fetchCompleteSlotDocData, tranferdata,getProgramCodes } = useUserAuth();
//   const bookedColors = ['#FADB8C', '#FADB8C', '#FADB8C', '#FADB8C'];
 
//   const handleSplashComplete = async () => {
//     console.log("this is user Data ",localStorage.getItem('userData'))
//     console.log("this is user Data ",localStorage.getItem('ID'))
//     if (localStorage.getItem('userData')) {
//       // const userData = JSON.parse(localStorage.getItem('userData'));
//       // localStorage.setItem('phoneNumber', userData.phoneNumber);
//       if(localStorage.getItem('ID'))
//         navigate('/home');
//       else
//         navigate('/phone')
//     } else {
//       navigate('/phone');
//     }
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       // console.log("this in function index");
//       // await tranferdata();
//       const codes = await getProgramCodes();
//       localStorage.setItem('codes', JSON.stringify(codes));
//       const data = await GetAllPhysioData();
//       localStorage.setItem('Data', JSON.stringify(data));
//       console.log(" Patient data is ", JSON.stringify(data, null, 2));
//       // const data2 = await VideoCallHistoryData();
//       // localStorage.setItem('VideoCallHistoryData', JSON.stringify(data2));
//       const data1 = await WeeklyUpcomingAppointmentsData();
//       const filteredData = data1.filter(item => item.ConsultationCompleted === false);
//       localStorage.setItem('WeeklyUpcomingAppointmentsData', JSON.stringify(filteredData));
//       const output = await programRenewalData();
//       // console.log("output is component index", output);
//       localStorage.setItem('ProgramRenewalData', JSON.stringify(output));
//       const completeSlotData = await fetchCompleteSlotData();
//         if (completeSlotData) {
//           // Process the data and convert it into events format
//           const newEvents = [];
//           for (const date in completeSlotData) {
//             completeSlotData[date].forEach((slot, index) => {
//               const isBooked = slot.ID.startsWith('booked');
//               const color = isBooked ? bookedColors[index % bookedColors.length] : undefined;
//               const eventTitle = slot.Name || 'Blocked';
//               newEvents.push({
//                 id: newEvents.length + 1,
//                 ID: `${slot.ID}`,
//                 title: eventTitle,
//                 start: moment(`${date} ${slot.start}`, 'DD/MM/YYYY HH:mm').toDate(),
//                 end: moment(`${date} ${slot.end}`, 'DD/MM/YYYY HH:mm').toDate(),
//                 className: isBooked ? 'booked-event' : "not-yetbooked",
//                 color: color,
//               });
//             });
//           }
        
//           // console.log("this is actual calender event  ",newEvents);
//           localStorage.setItem('CalenderEvents', JSON.stringify(newEvents));
//           setEvent(newEvents);
//         }

//       // for Doctors Calender Data 
//       const completeDocSlotData = await fetchCompleteSlotDocData();
//       if (completeSlotData) {
//         // Process the data and convert it into events format
//         const newEvents = [];
//         for (const date in completeSlotData) {
//           completeSlotData[date].forEach((slot, index) => {
//             let isBooked = false;

//             try {
//               isBooked = slot.ID && slot.ID.startsWith('booked');
//             } catch {
//               isBooked = false;
//             }

//             const color = isBooked ? bookedColors[index % bookedColors.length] : undefined;
//             const eventTitle = slot.Name || 'Blocked';

//             // Ensure properties exist before accessing them
//             const start = slot.start ? new Date(date + ' ' + slot.start) : null;
//             const end = slot.end ? new Date(date + ' ' + slot.end) : null;

//             newEvents.push({
//               id: newEvents.length + 1,
//               ID: `${slot.ID}`,
//               title: eventTitle,
//               start: start,
//               end: end,
//               className: isBooked ? 'booked-event' : "not-yetbooked",
//               color: color,
//               appointmentType: slot.appointmentType || '',
//               appointmentStartTime: slot.appointmentStartTime || '',
//               day: slot.day || '',
//               remainingMinutes: slot.remainingMinutes || '',
//               slotDuration: slot.slotDuration || '',
//               patientName: slot.patientname || '', // Add check for patientName
//               patientNumber: slot.patientnumber || '' // Add check for patientNumber
//             });
//           });
//         }
        
//         console.log("this is actual calendar event  ", newEvents);
//         localStorage.setItem('DocCalenderEvents', JSON.stringify(newEvents));
//         // setEvents(newEvents);
//         setDocEvent(newEvents);
//       }
//       const programsData = await getAllPrograms();
//       localStorage.setItem('Program', JSON.stringify(programsData));
      
      
//       const userData = await fetchPhysioData();
//       if (userData) {
//         console.log("this is user data in index page", userData.Name, userData.About, userData.ConsultancyPrice);
//         localStorage.setItem('py_username', userData.Name);
//         localStorage.setItem('py_About', userData.About);
//         localStorage.setItem('py_Price', userData.ConsultancyPrice);
//       }
      
      

//     };
//     const tranferingdata = async () => {
//       await ADDingdata();
//     }


//     fetchData();
//     // tranferingdata();
//   }, [user]);

//   return (
//     <div>
//         <SplashScreen onSplashComplete={handleSplashComplete} />

//         <NoInternetPopup />
      
//     </div>
//     // <div>
//     //   <SplashScreen onSplashComplete={handleSplashComplete} >
//     //   </SplashScreen>
//     // </div>
//   );
// };

import React, { useEffect } from 'react';
import { useUserAuth } from '../context/UserAuthContext';
import { useNavigate } from 'react-router-dom';
import SplashScreen from './components/SplashScreen';
import moment from 'moment';
import NoInternetPopup from './components/NoInternetPopup';

const buildCalendarEvents = (slotData, bookedColors) => {
  const newEvents = [];
  for (const date in slotData) {
    slotData[date].forEach((slot, index) => {
      let isBooked = false;
      try { isBooked = slot.ID && slot.ID.startsWith('booked'); } catch { }
      newEvents.push({
        id: newEvents.length + 1,
        ID: `${slot.ID}`,
        title: slot.Name || 'Blocked',
        start: slot.start ? moment(`${date} ${slot.start}`, 'DD/MM/YYYY HH:mm').toDate() : null,
        end: slot.end ? moment(`${date} ${slot.end}`, 'DD/MM/YYYY HH:mm').toDate() : null,
        className: isBooked ? 'booked-event' : 'not-yetbooked',
        color: isBooked ? bookedColors[index % bookedColors.length] : undefined,
        appointmentType: slot.appointmentType || '',
        appointmentStartTime: slot.appointmentStartTime || '',
        day: slot.day || '',
        remainingMinutes: slot.remainingMinutes || '',
        slotDuration: slot.slotDuration || '',
        patientName: slot.patientname || '',
        patientNumber: slot.patientnumber || '',
      });
    });
  }
  return newEvents;
};

export const Index = () => {
  const navigate = useNavigate();
  const {
    user,
    programRenewalData,
    setEvent,
    setDocEvent,
    getAllPrograms,
    GetAllPhysioData,
    fetchPhysioData,
    WeeklyUpcomingAppointmentsData,
    fetchCompleteSlotData,
    fetchCompleteSlotDocData,
    getProgramCodes,
  } = useUserAuth();

  const bookedColors = ['#FADB8C', '#FADB8C', '#FADB8C', '#FADB8C'];
 
  const handleSplashComplete = async () => {
    console.log("this is user Data ",localStorage.getItem('userData'))
    console.log("this is user Data ",localStorage.getItem('ID'))
    if (localStorage.getItem('userData')) {
      navigate(localStorage.getItem('ID') ? '/home' : '/phone');
    } else {
      navigate('/phone');
    }
  };

  useEffect(() => {
    if (!user) return;

    const fetchData = async () => {
      try {
        const [
          // codes,
          data,
          // data1,
          renewalOutput,
          // completeSlotData,
          // completeDocSlotData,
          programsData,
          userData,
        ] = await Promise.allSettled([
          // getProgramCodes(),
          GetAllPhysioData(),
          // WeeklyUpcomingAppointmentsData(),
          programRenewalData(),
          // fetchCompleteSlotData(),
          // fetchCompleteSlotDocData(),
          getAllPrograms(),
          fetchPhysioData(),
        ]);

        // Codes
        // if (codes.status === 'fulfilled' && codes.value) {
        //   localStorage.setItem('codes', JSON.stringify(codes.value));
        // }

        // Patient data
        console.log("patient data status is ", data.status, data.value);
        if (data.status === 'fulfilled' && data.value) {
          console.log(" Patient data is ", JSON.stringify(data.value, null, 2), data);
          localStorage.setItem('Data', JSON.stringify(data.value));
          localStorage.setItem('DataUpdatedAt', String(Date.now()));
        }

        // Weekly appointments
        // if (data1.status === 'fulfilled' && data1.value) {
        //   const filtered = data1.value.filter(item => item.ConsultationCompleted === false);
        //   localStorage.setItem('WeeklyUpcomingAppointmentsData', JSON.stringify(filtered));
        // }

        // Program renewal
        if (renewalOutput.status === 'fulfilled' && renewalOutput.value) {
          localStorage.setItem('ProgramRenewalData', JSON.stringify(renewalOutput.value));
        }

        // Physio calendar
        // if (completeSlotData.status === 'fulfilled' && completeSlotData.value) {
        //   const events = buildCalendarEvents(completeSlotData.value, bookedColors);
        //   localStorage.setItem('CalenderEvents', JSON.stringify(events));
        //   setEvent(events);
        // }

        // Doctor calendar
        // if (completeDocSlotData.status === 'fulfilled' && completeDocSlotData.value) {
        //   const docEvents = buildCalendarEvents(completeDocSlotData.value, bookedColors);
        //   localStorage.setItem('DocCalenderEvents', JSON.stringify(docEvents));
        //   setDocEvent(docEvents);
        // }

        // Programs
        console.log("programs data status is ", programsData.status, programsData.value, programsData);
        if (programsData.status === 'fulfilled' && programsData.value) {
          localStorage.setItem('Program', JSON.stringify(programsData.value));
        }

        // User profile
        if (userData.status === 'fulfilled' && userData.value) {
          const u = userData.value;
          console.log("this is user data in index page", u.Name, u.About, u, u.value);
          localStorage.setItem('py_username', u.Name || '');
          localStorage.setItem('py_About', u.About || '');
          localStorage.setItem('py_Price', u.ConsultancyPrice || '');
        }

      } catch (err) {
        // Promise.allSettled never throws — this is a safety net
        console.error('Index fetchData unexpected error:', err);
      }
    };

    fetchData();
  }, [user]);

  return (
    <div>
      <SplashScreen onSplashComplete={handleSplashComplete} />
      <NoInternetPopup />
    </div>
  );
};